<div>
    <p-menubar [model]="topMenuItems"></p-menubar>
</div>
<div>
    <h3>Create new invoice (To be paid)</h3>
</div>
<p-dialog [(visible)]="isSupplierDialogVisible" [modal]="true" header="Add new supplier">
    <div class="supplier-form-container">
        <div [formGroup]="supplierForm">
            <span>
                Name
            </span>
            <input pInputText formControlName="name">
        </div>
        <div>
            <p-button label="Submit" (onClick)="submitSupplier()"></p-button>
        </div>
    </div>
</p-dialog>

<div [formGroup]="invoiceForm">
    <table>
        <tr>
            <td>
                Supplier
            </td>
            <td>
                <div class="supplier-container">
                    <p-dropdown placeholder="Select" [options]="suppliers" optionLabel="name" formControlName="supplier"></p-dropdown>
                    <p-button icon="pi pi-plus" label="Add" (onClick)="activateSupplierDialog()"></p-button>
                </div>
            </td>
        </tr>
        <tr>
            <td>
                Invoice number
            </td>
            <td>
                <input pInputText formControlName="invoiceNumber">
            </td>
        </tr>
        <tr>
            <td>
                Invoice date
            </td>
            <td>
                <p-calendar formControlName="date"></p-calendar>
            </td>
        </tr>
        <tr>
            <td>
                Payment method
            </td>
            <td>
                <p-dropdown placeholder="Select" [options]="paymentTypes" optionLabel="name" formControlName="paymentType"></p-dropdown>
            </td>
        </tr>
        <tr>
            <td>
                Amount
            </td>
            <td>
                <input pInputText formControlName="amount">
                <span>EUR</span>
            </td>
        </tr>
        <tr>
            <td>File</td>
            <td>
                <p-fileUpload #fileUploader mode="basic" [auto]="false" (onSelect)="onFileSelect($event.currentFiles)"
                    [maxFileSize]="16000000" chooseIcon="pi pi-none" chooseLabel="Upload file">
                </p-fileUpload>
            </td>
        </tr>
        <tr>
            <td>
                Comment
            </td>
            <td>
                <textarea pInputTextarea rows="10" cols="50" formControlName="comment"></textarea>
            </td>
        </tr>
        <tr *ngIf="isInvoiceValidator">
            <td>Validated for payment</td>
            <td>
                <p-checkbox [binary]="true" formControlName="isValidated"></p-checkbox>
            </td>
        </tr>
    </table>

    <div>
        <p-button label="Submit" [disabled]="isCreatingInvoice" (onClick)="submit()"></p-button>
    </div>
</div>